module.exports = __webpack_public_path__ + "assets/redx.aaf80db5b02944d901fdc1d098031f31.png";